import {
  CorrectionMaterial,
  TransactionMaterial,
} from "fe-shared-transactions/src/types";
import { EditInventoryAdjustmentFormContent } from "../../../components/EditInventoryAdjustmentDialog";
import { ActionType } from "../../../types/inventoryAdjustments";
import { EditInventoryAdjustmentParams } from "./types";
import { AdjustmentMaterial } from "../../../components/EditInventoryAdjustmentDialog/modules/types";

const mapMaterials = (
  materials?: (TransactionMaterial | AdjustmentMaterial)[]
): CorrectionMaterial[] => {
  if (!materials) return [];

  return materials.map((material) => ({
    materialCode: material.materialCode,
    units: {
      unit: material.units.unit,
      unitQuantity: Math.abs(material.units.unitQuantity),
    },
  }));
};

export const mapEditParams = ({
  inputValues,
  actionType,
  addition,
  subtraction,
  overallAdjustmentNumber,
}: {
  actionType: ActionType;
  overallAdjustmentNumber: string;
  addition?: TransactionMaterial[];
  subtraction?: TransactionMaterial[];
  inputValues: EditInventoryAdjustmentFormContent;
}): EditInventoryAdjustmentParams => {
  const isAddition = actionType === "addition";
  const mappedUpdates: CorrectionMaterial[] = mapMaterials(
    inputValues.materials
  );
  const mappedSubtraction: CorrectionMaterial[] = mapMaterials(subtraction);
  const mappedAdditions: CorrectionMaterial[] = mapMaterials(addition);

  return {
    overallAdjustmentNumber,
    comment: inputValues.comment,
    additions: isAddition ? mappedUpdates : mappedAdditions,
    subtractions: isAddition ? mappedSubtraction : mappedUpdates,
  };
};

export default {
  mapEditParams,
};
